import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GridsterModule } from 'angular-gridster2';
import { ToastrModule } from 'ngx-toastr';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../pipes/pipes.module';
import { PartyProfilerComponent } from './party-profiler.component';
import { PartyProfilerService } from './party-profiler.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/");
}

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        ProgressBarModule,
        GridsterModule,
        CalendarModule,
        InputNumberModule,
        InputSwitchModule,
        InputTextModule,
        RippleModule,
        TableModule,
        DropdownModule,
        CheckboxModule,
        TooltipModule,
        ChartModule,
        ReactiveFormsModule,
        FormsModule,
        FileUploadModule,
        PipesModule,
        TranslateModule,
        ToastrModule.forRoot({
            timeOut: 2500,
            enableHtml: true,
            positionClass: 'toast-top-right'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        PartyProfilerComponent
    ],
    providers: [
        PartyProfilerService
    ],
    exports: [
        PartyProfilerComponent
    ],
})

export class PartyProfilerModule {

}

